import './AlertCheckMail.scss';
import { Icon } from '../../icon/icon';
import ButtonIconGhostMedium from '../../common/ButtonIconGhost/ButtonIconGhostMedium';
import { Form } from 'antd';
import { Modal } from 'antd';
import ButtonSecondaryLarge from '../../common/ButtonSecondary/ButtonSecondaryLarge';
import { useRef } from 'react';
import { openModal } from '../../common/Modal/openModal';

const useModalAlertCheckMail = () => {
  const modal = useRef(null);
  const openModalAlertCheckMail = ({ email, openLogin }) => {
    modal.current = openModal({
      content: (
        <>
          <Form layout="vertical">
            <div className="flex py-16 px-40 justify-center items-center gap-8 self-stretch">
              <h2>Kiểm tra email của bạn</h2>
            </div>
            <div className="flex py-16 px-40 justify-center items-center gap-16 flex-col self-stretch">
              <span className="text-label-large" style={{ color: '#818589' }}>
                Chúng tôi đã gửi một email đến{' '}
                <span className="text-title-medium">{email}</span> một đường dẫn
                đặt lại mật khẩu mới, hãy kiểm tra họp thư của bạn nhé.
              </span>
            </div>
            <div className="flex p-40 pt-16 justify-center items-center gap-8 self-stretch">
              <ButtonSecondaryLarge
                title={'Trở về đăng nhập'}
                posIcon={<Icon.ICArrowBack />}
                onClick={() => {
                  modal.current?.destroy();
                  openLogin();
                }}
              />
            </div>
          </Form>
        </>
      ),
      title: (
        <div className="flex p-40 pb-16 justify-center items-center self-stretch m-0">
          <div
            style={{
              backgroundImage: 'url(/assets/icons/icon_sendemail.png)',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              height: '80px',
              width: '80px',
            }}
          ></div>
          <ButtonIconGhostMedium
            icon={<Icon.ICClose />}
            style={{ border: '1px solid #CFD1D2' }}
            className={'absolute top-24 right-24'}
            onClick={() => modal.current?.destroy()}
          />
        </div>
      ),
      footer: null,
      centered: true,
      closable: false,
      classNames: { content: '!p-0 !rounded-[8px]', header: '!m-0' },
      width: 620,
      styles: {
        mask: {
          background: 'rgba(221, 221, 221, 0.38)',
          backdropFilter: 'blur(8px)',
        },
      },
    });
  };
  return { openModalAlertCheckMail };
};

// const AlertCheckMail = ({ open, onClose }) => {
//   return (
//     <Modal
//       title={
//         <div className="flex p-40 pb-16 justify-center items-center self-stretch m-0">
//           <div
//             style={{
//               background: 'url(/assets/icons/icon_sendemail.png',
//               height: '80px',
//               width: '80px',
//             }}
//           ></div>
//           <ButtonIconGhostMedium
//             icon={<Icon.ICClose />}
//             style={{ border: '1px solid #CFD1D2' }}
//             className={'absolute top-24 right-24'}
//             onClick={onClose}
//           />
//         </div>
//       }
//       closable={false}
//       classNames={{ content: '!p-0', header: 'm-0' }}
//       styles={{
//         mask: {
//           background: 'rgba(221, 221, 221, 0.38)',
//           backdropFilter: 'blur(8px)',
//         },
//       }}
//       centered
//       width={620}
//       open={open !== undefined}
//       onOk={() => {}}
//       footer={null}
//       onCancel={() => {}}
//     >
//       <Form layout="vertical">
//         <div className="flex py-16 px-40 justify-center items-center gap-8 self-stretch">
//           <h2>Kiểm tra email của bạn</h2>
//         </div>
//         <div className="flex py-16 px-40 justify-center items-center gap-16 flex-col self-stretch">
//           <span className="text-label-large" style={{ color: '#818589' }}>
//             Chúng tôi đã gửi một email đến{' '}
//             <span className="text-title-medium">{open}</span> một đường dẫn đặt lại
//             mật khẩu mới, hãy kiểm tra họp thư của bạn nhé.
//           </span>
//         </div>
//         {/* <div className="flex p-40 pt-16 justify-center items-center gap-8 self-stretch">
//           <ButtonSecondaryLarge
//             title={'Nhận liên kết đặt lại'}
//             onClick={() => {
//               window.location.href = 'https://mail.google.com/mail/';
//               onClose();
//             }}
//           />
//         </div> */}
//       </Form>
//     </Modal>
//   );
// };

export default useModalAlertCheckMail;
